module.exports = __webpack_public_path__ + "img/youtube-line-light.48402fe.svg";